

















import Vue from 'vue';
import { VBTooltip } from 'bootstrap-vue';

export default Vue.extend({
  name: 'Edit',
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
});
